/** Appends a `<link rel>` resource hint to <head>, once per rel + href. Prefetches are always iframe documents. */
export function addResourceHint(rel: 'preconnect' | 'prefetch', href: string | undefined, crossOrigin?: 'anonymous') {
  if (!href || document.querySelector(`link[data-resource-hint][rel="${rel}"][href="${href}"]`)) {
    return;
  }

  const link = document.createElement('link');
  link.rel = rel;
  link.href = href;
  if (rel === 'prefetch') {
    link.as = 'document';
  }
  if (crossOrigin) {
    link.crossOrigin = crossOrigin;
  }
  link.setAttribute('data-resource-hint', '');
  document.head.appendChild(link);
}
